import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import {
    Box,
    Typography,
    Button,
    TextField,
    Card,
    Divider,
    Modal,
    Grid,
    CardMedia,
    CardContent
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { CheckInApi, getBookingByID, UpdateBooking } from '../../../service/booking_service';
import { AlertError, AlertLoading, AlertSuccess } from '../../../component/popupAlert';
import AppBarComponent from '../../../component/appbar';
import { ChooseBoatTobooking, GetBoatData, getBoatDataActive } from '../../../service/boat_service';
import bg_pic from '../../../images/bg_website.png';
import '../../../style/style.css';

const CheckIn_View = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    const token = Cookies.get('token');

    const [loadingBoat ,setLoadingBoat ] = useState(false)
    const [bookingId, setBookingId] = useState('');
    const [boatData, setBoatData] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalOpenBoat, setModalOpenBoat] = useState(false);
    const [bookingData, setBookingData] = useState({});
    const [dataOpen, setDataOpen] = useState(false);
    const [selectedBoat, setSelectedBoat] = useState(null);

    useEffect(() => {
        if (!token) {
            navigate('/login');
        }
        handleGetBoatData();
    }, [token, navigate]);

    const handleGetBookingById = async () => {
        try {
            const res = await getBookingByID({ token, id: bookingId });
            // console.log("booking Data",res);
            setBookingData(res.data);
            setSelectedBoat({name : res.data.boatName}); //
            setDataOpen(true);
        } catch (error) {
            console.error("Error fetching booking data:", error);
            AlertError('ไม่สามารถดึงข้อมูลได้', error.message);
        }
    }

    const getCurrentDate = () => {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const year = today.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const handleCheckDateTicket = ()=>{
        const today = getCurrentDate()
        if(bookingData.date === today){
            return true;
        }else{
            return false;
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (bookingId === '') {
            AlertError("เกิดข้อผิดพลาด", 'กรุณาระบุหมายเลขการจอง');
            return;
        }
        try {
            handleGetBookingById();
        } catch (error) {
            AlertError("เกิดข้อผิดพลาด", error);
        }
    }

    const handleChange = (event) => {
        setBookingId(event.target.value);
    }

    const handleStatusUpdate = async () => {
        // setModalOpen(true);
        setModalOpenBoat(true);
        // AlertLoading();
        // try {
        //     const updatedData = { ...bookingData, status };
        //     await UpdateBooking(updatedData, token);
        //     setBookingData(updatedData);
        //     AlertSuccess('อัพเดทสถานะสำเร็จ');
        // } catch (error) {
        //     AlertError('อัพเดทผิดพลาด', error.message);
        // }
    };

    

    const handleGetBoatData = async () => {
        try {
            setLoadingBoat(false);
            const res = await getBoatDataActive();
            setBoatData(res);
            setLoadingBoat(true);
        } catch (error) {
            AlertError('ไม่สามารถดึงข้อมูลเรือได้', error.message);
        }
    }

    const handleBoatSelect = (boat) => {
        setSelectedBoat(boat);
    }

    const handleOpenModal = () => {
        setModalOpen(true);
    }

    const handleCloseModal = () => {
        setModalOpen(false);
    }

    const handleChangeEdit = (event) => {
        const { name, value } = event.target; 
        // console.log(name, value);
        setBookingData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSaveBoatSelection = async () => {
        if (selectedBoat) {
            // Here you would typically update the booking with the selected boat
            AlertLoading()
            try {
                const data = {...bookingData}
                data.boat_id = selectedBoat.boat_id
                data.boatName = selectedBoat.name
                // const res = await CheckInApi({ id: bookingData.id, status: "เสร็จสิ้น", boatName: selectedBoat.name, date: bookingData.date, time: bookingData.time }, token)
                const res = await CheckInApi(data,token);
                AlertSuccess("สำเร็จ", "แก้ไขข้อมูลสำเร็จ")
            } catch (error) {
                console.error(error)
                AlertError('ไม่สามารถทำการเช็คอินได้', error.message);
            }
        } else {
            AlertError('กรุณาเลือกเรือ');
        }
        handleCloseModal();
        setDataOpen(false);
        setModalOpenBoat(false);
    }

    const renderModal = () => (
        <Modal
            open={modalOpen}
            onClose={setModalOpen}
            aria-labelledby="select-boat-modal"
            aria-describedby="modal-to-select-boat"
        >
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 500,
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4,
                borderRadius: 2,
            }}>
                <Box sx={{ margin: 4 }}>
                    <Typography variant="h6" component="h2" gutterBottom>
                        เลือกเรือ
                    </Typography>
                    <Divider />
                    <Box sx={{ marginTop: 1 }}>
                        <Grid container spacing={2}>
                            {boatData.map((boat) => (
                                <Grid item xs={6} key={boat.id}>
                                    <Card
                                        onClick={() => handleBoatSelect(boat)}
                                        sx={{
                                            cursor: "pointer",
                                            border: selectedBoat?.id === boat.id
                                                ? `2px solid ${theme.palette.primary.main}`
                                                : "none",
                                        }}
                                    >
                                        <CardMedia
                                            component="img"
                                            height="100"
                                            image={"data:image/png;base64," + boat.image}
                                            alt={boat.name}
                                        />
                                        <CardContent>
                                            <Typography variant="body2" component="div">
                                                {boat.name}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{ mt: 3 }}
                        onClick={handleSaveBoatSelection}
                        disabled={!selectedBoat}
                    >
                        บันทึก
                    </Button>
                </Box>
            </Box>
        </Modal>
    );

    const BoatSelectionModal = () => {
        return (
            <Modal
                open={modalOpenBoat}
                onClose={()=>setModalOpenBoat(false)}
                aria-labelledby="select-boat-modal"
                aria-describedby="modal-to-select-boat"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 1200,
                    height: 800,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    display: 'flex',
                }}>
                    {/* Left side - Boat selection */}
                    <Box sx={{ width: '50%', height: '100%', overflowY: 'auto', pr: 2, }}>
                        <Box sx={{ margin: 4 }}>
                            <Typography variant="h6" component="h2" gutterBottom>
                                {!loadingBoat ? "กำลังโหลดข้อมูลเรือ..." : "เลือกเรือ"}
                            </Typography>
                            <Divider />
                            <Grid container spacing={2} sx={{ mt: 1 }}>
                                {boatData.map((boat) => (
                                    <Grid item xs={6} key={boat.id}>
                                        <Card
                                            onClick={() => handleBoatSelect(boat)}
                                            sx={{
                                                cursor: "pointer",
                                                border: selectedBoat?.name === boat.name
                                                    ? `2px solid ${theme.palette.primary.main}`
                                                    : "none",
                                                height: '100%',
                                                display: 'flex',
                                                flexDirection: 'column',
                                            }}
                                        >
                                            <CardMedia
                                                component="img"
                                                height="100"
                                                image={"data:image/png;base64," + boat.image}
                                                alt={boat.name}
                                                sx={{ objectFit: 'cover' }}
                                            />
                                            <CardContent sx={{ flexGrow: 1 }}>
                                                <Typography variant="body2" component="div">
                                                    {boat.name}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    </Box>

                    {/* Right side - Input fields */}
                    <Box sx={{ width: '50%', height: '100%', pl: 2 }}>
                        <Box sx={{ margin: 4 }}>
                            <Typography variant="h6" component="h2" gutterBottom>
                                ข้อมูลเพิ่มเติม
                            </Typography>
                            <Divider />
                            <Box sx={{ mt: 2 }}>
                                <Typography sx={{ mb: 1 }}>เลือกพนักงานขับ</Typography>
                                <TextField
                                    fullWidth
                                    name="driverName"
                                    label="พนักงานขับ"
                                    value={bookingData.driverName}
                                    onChange={handleChangeEdit}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    sx={{ mb: 2 }}
                                />
                                <Typography sx={{ mb: 1 }}>เลือกผู้ช่วย</Typography>
                                <TextField
                                    fullWidth
                                    name="butlerName"
                                    label="ผู้ช่วย"
                                    value={bookingData.butlerName}
                                    onChange={handleChangeEdit}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    sx={{ mb: 2 }}
                                />
                            </Box>
                            <Box>
                                <Typography sx={{ margin: '8px' }}>หมายเหตุ</Typography>
                                <TextField
                                    fullWidth
                                    name="noteBoat"
                                    label="หมายเหตุ"
                                    value={bookingData.noteBoat}
                                    onChange={handleChangeEdit}
                                    multiline
                                    minRows={3} // กำหนดจำนวนแถวขั้นต่ำ
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Box>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                sx={{ mt: 3 }}
                                onClick={handleSaveBoatSelection}
                                disabled={!selectedBoat}
                            >
                                {!loadingBoat ? "กำลังโหลด..." : "บันทึก"}
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>
        );
    };

    const renderBookingDetails = () => (
        <>
            <BookingDetailItem label="ชื่อผู้จอง" value={`${bookingData.first_name} ${bookingData.last_name}`} />
            <BookingDetailItem label="วันที่" value={bookingData.date} />
            <BookingDetailItem label="รอบ" value={bookingData.time} />
            <BookingDetailItem label="จำนวน 'ผู้ใหญ่'" value={`${bookingData.adults} คน`} />
            <BookingDetailItem label="จำนวน 'เด็ก'" value={`${bookingData.children} คน`} />
            <BookingDetailItem label="สถานะการชำระ" value={bookingData.status} />
            <Divider sx={{ my: 2 }} />
            <BookingDetailItem label="ราคารวม (รวมภาษีมูลค่าเพิ่ม)" value={`${bookingData.total_price} บาท`} isBold />
            <Box justifyContent="end" alignItems={'flex-end'} gap={2}>
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    sx={{ mt: 2 }}
                    onClick={() => handleStatusUpdate("เสร็จสิ้น")}
                    disabled={bookingData.status === "เสร็จสิ้น" || bookingData.status === "ยกเลิก"}
                >
                    ยืนยันการจอง
                </Button>
            </Box>
        </>
    );

    const BookingDetailItem = ({ label, value, isBold = false }) => (
        <Box display="flex" justifyContent="space-between" mb={1}>
            <Typography fontSize={24} fontWeight={isBold ? "bold" : "normal"}>{label}</Typography>
            <Typography fontSize={24} fontWeight={isBold ? "bold" : "normal"}>{value}</Typography>
        </Box>
    );

    return (
        <Box>
            <AppBarComponent />
            <Box sx={{
                minHeight: '100vh',
                width: '100%',
                backgroundImage: `
                linear-gradient(to top, rgba(255, 255, 255, 255) 20%, rgba(0, 0, 0, 0) 100%),
                url(${bg_pic})`,
                backgroundSize: '100% auto',
                backgroundPosition: 'top', // ชิดขอบบน
                backgroundRepeat: 'no-repeat',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-start', // ชิดขอบบนของเนื้อหาด้านใน
                width: '100%', // กว้างเต็มหน้าจอ
                height: '100vh', // สูงเต็มหน้าจอ
                minHeight: '100vh',
                overflow: 'hidden',
                padding: '50px 0px 10px 0px',
            }}>
                <Box
                    sx={{
                        position: 'relative',
                        minHeight: '64vh',
                        marginTop: '50px',
                        borderRadius: 3,
                        width: '80%',
                        boxShadow: '0px 0px 25px #888',
                        padding: theme.spacing(2),
                        '&::before': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0,
                            backgroundColor: 'white',
                            opacity: 0.5,
                            borderRadius: 'inherit',
                        }
                    }}>
                    <LocalizationProvider className="checkInBox" dateAdapter={AdapterDateFns} sx={{ border: '0px solid #f00' }}>
                        <Box className="checkInTicketBox" display="flex" justifyContent="space-between" gap={2} sx={{ minHeight: '64vh', margin: '20px', border: '0px solid #f00', position: 'relative', height: '100%' }}>
                            <Card sx={{ width: '35%', padding: '16px', boxShadow: 5, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%', maxWidth: 400 }}>
                                    <Typography variant="h6" component="h1" gutterBottom fontWeight={'bold'} marginTop={4}>
                                        ระบุข้อมูลหมายเลขตั๋ว
                                    </Typography>
                                    <TextField
                                        label="หมายเลขตั๋ว"
                                        variant="outlined"
                                        onChange={handleChange}
                                        value={bookingId}
                                        fullWidth
                                        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                    />
                                    <Button variant="contained" color="primary" type="submit">
                                        Submit
                                    </Button>
                                </Box>
                            </Card>

                            <Card sx={{ width: '65%', height: '50vh', boxShadow: 5, padding: 2, minHeight: '64vh', position: 'relative', height: '100%' }}>
                                <Box display="flex" flexDirection="column" gap={2} justifyContent={'space-between'} padding={4}>
                                    {dataOpen ? renderBookingDetails() : (
                                        <Typography gutterBottom fontWeight={'bold'} color={'#1a237e'} fontSize={'24px'}>
                                            กรุณากรอกหมายเลขตั๋วและกด Submit เพื่อดูข้อมูลการจอง
                                        </Typography>
                                    )}
                                </Box>
                            </Card>
                        </Box>
                    </LocalizationProvider>
                </Box>
            </Box>
            {renderModal()}
            {BoatSelectionModal()}
        </Box>
    );
};

export default CheckIn_View;